'use client';

import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import SinglePatientInfo from '../../Components/Global_Components/common/SinglePatientInfo';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {fetchPatientDetailsUuid, postAppointment, postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {bmiValue, handleNill, labelStyles, renderReportfield, renderTableTD, renderTableTH} from '../../utils/templateUtils';
import './scFetStimulated.scss';

export default function ScFetStimulatedTemplate(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    status: 'Not Visited',
    notes: '',
    patient_id: ''
  });

  const medicationHeaders = [
    {key: 'sno', label: 'S.No'},
    {key: 'medication', label: 'Medication'},
    {key: 'genericName', label: 'Generic Name'},
    {key: 'dose', label: 'Dose'},
    {key: 'frequency', label: 'Frequency'},
    {key: 'timing', label: 'Timing'},
    {key: 'route', label: 'Route'},
    {key: 'days', label: 'Days'}
  ];

  const [medicationRows, setMedicationRows] = useState([
    {
      sno: 1,
      medication: 'T.Stimucor / Letroz',
      genericName: 'Letrozole',
      dose: '5 mg',
      frequency: '0-0-1',
      timing: 'After food',
      route: 'Oral',
      days: '5'
    },
    {
      sno: 2,
      medication: 'C.Folvista',
      genericName: 'L-methylfolate + Myoinositol',
      dose: '-',
      frequency: '0-0-1',
      timing: 'After food',
      route: 'Oral',
      days: '30'
    },
    {
      sno: 3,
      medication: 'Tab. Ecosprin 75/150',
      genericName: 'Aspirin 75/150 mg',
      dose: '1 tablet',
      frequency: '0-0-1',
      timing: 'in the night after meal',
      route: 'Oral',
      days: '30'
    },
    {
      sno: 4,
      medication: 'T.Tamoxifen/Mamofen',
      genericName: 'Tamoxifen Citrate',
      dose: '10 mg',
      frequency: '1-0-1',
      timing: 'After food',
      route: 'Oral',
      days: '10'
    },
    {
      sno: 5,
      medication: 'T.Sildenafil',
      genericName: 'Sildenafil Citrate',
      dose: '25 mg',
      frequency: '0-0-2',
      timing: '-',
      route: 'Vaginal',
      days: '15'
    },
    {
      sno: 6,
      medication: 'T.Thyronorm',
      genericName: 'Levothyroxine',
      dose: '-',
      frequency: '1-0-0',
      timing: 'Empty stomach',
      route: 'Oral',
      days: '30'
    },
    {
      sno: 7,
      medication: 'T.Glycomet SR',
      genericName: 'Metformin SR',
      dose: '500 mg',
      frequency: '1-0-1',
      timing: 'After food',
      route: 'Oral',
      days: '30'
    },
    {
      sno: 8,
      medication: 'T.HCQ',
      genericName: 'Hydroxychloroquine',
      dose: '200 mg',
      frequency: '1-0-1',
      timing: 'After food',
      route: 'Oral',
      days: '30'
    },
    {
      sno: 9,
      medication: 'T.Wysolone',
      genericName: 'Prednisolone',
      dose: '10 mg',
      frequency: '1-0-0',
      timing: 'After food',
      route: 'Oral',
      days: '20 days'
    },
    // {
    //   sno: 10,
    //   medication: "T.Glucomet SR",
    //   genericName: "Metformin SR",
    //   dose: "500 mg",
    //   frequency: "1-0-1",
    //   timing: "After food",
    //   route: "Oral",
    //   days: "20 days",
    // },
    {
      sno: 10,
      medication: 'Inj.Evaparin(LMWH)',
      genericName: 'Evaparin',
      dose: '40/60 mg',
      frequency: 'Daily once/alternate days',
      timing: '-',
      route: 'SC',
      days: '20 days'
    },
    {
      sno: 11,
      medication: 'Argipreg/L arg sachet',
      genericName: 'L-Arginine',
      dose: '',
      frequency: 'once daily',
      timing: 'After food',
      route: 'Oral',
      days: '30 days'
    },
    {
      sno: 12,
      medication: 'Inj.puregraf/puma for follisurge',
      genericName: 'Mentropin',
      dose: '75/150 mg',
      frequency: '-',
      timing: '-',
      route: 'IM/SC',
      days: 'As advised'
    },
    {
      sno: 13,
      medication: 'T.Tricium XT',
      genericName: 'Calcium Citrate Malate + Cholecalciferol (Vitamin D₃)',
      dose: '-',
      frequency: '0-1-0',
      timing: '-',
      route: '-',
      days: 'As advised'
    },
    {
      sno: 14,
      medication: 'T.Ultrafem',
      genericName: 'Iron Polymaltose Complex + Folic Acid',
      dose: '-',
      frequency: '1-0-1',
      timing: '-',
      route: '-',
      days: 'As advised'
    },
    {
      sno: 15,
      medication: 'T. C Vit / Celin',
      genericName: 'Vitamin C',
      dose: '500 mg',
      frequency: '1-0-1',
      timing: 'After food',
      route: 'Oral',
      days: '30 days'
    },
    {
      sno: 16,
      medication: 'T. Neuroplex / Neurobion',
      genericName: 'Vitamin B-complex',
      dose: '1 tab',
      frequency: 'OD',
      timing: 'After food',
      route: 'Oral',
      days: '30 days'
    },


  ]);

  const follicularHeaders = [
    // { key: "date", label: "Date" },
    {key: 'day', label: 'Day'},
    {key: 'rightOvary', label: 'Right Ovary (Follicle Size in mm)'},
    {key: 'leftOvary', label: 'Left Ovary (Follicle Size in mm)'},
    {key: 'endometrialThickness', label: 'Endometrial Thickness (mm)'},
    {key: 'notesActions', label: 'Notes / Actions'}
  ];

  const [follicularRows, setFollicularRows] = useState([
    {sno: 1, day: '', rightOvary: '', leftOvary: '', endometrialThickness: '', notesActions: ''},
    {sno: 2, day: '', rightOvary: '', leftOvary: '', endometrialThickness: '', notesActions: ''},
    {sno: 3, day: '', rightOvary: '', leftOvary: '', endometrialThickness: '', notesActions: ''},
    {sno: 4, day: '', rightOvary: '', leftOvary: '', endometrialThickness: '', notesActions: ''},
    {sno: 5, day: '', rightOvary: '', leftOvary: '', endometrialThickness: '', notesActions: ''}
  ]);
  const hormonalProfileHeaders = [
    {key: 'hormone', label: 'Hormone'},
    {key: 'valueTestDate', label: 'Value Test Date'}
  ];

  const [hormonalProfileRows, setHormonalProfileRows] = useState([
    {hormone: 'Prolactin (PRL)', valueTestDate: ''},
    {hormone: 'Estradiol (E2)', valueTestDate: ''},
    {hormone: 'Progesterone (P4)', valueTestDate: ''},
    {hormone: 'Thyroid (TSH)', valueTestDate: ''},
    {hormone: 'HbA1c', valueTestDate: ''}
  ]);

  const [showTables, setShowTables] = useState({
    medicationChart: true,
    follicularMonitoring: true,
    hormonalProfile: true
  });

  const handleChange = e => {
    var text = e.target.value;

    if (e.target.name === 'patientId') {
      if (/^(ASCAS|VDASCAS)\d+$/i.test((e.target.value || '').trim())) {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value
          };
          props.loaderchange('true');
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat = data?.titles + ' ' + data?.first_name + ' ' + data?.last_name;
            setFormData({
              ...formData,
              patientName: namePat,
              age: data?.age,
              gender: data?.gender,
              patientId: text
            });
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        setFormData({
          ...formData,
          patientId: e.target.value
        });
      }
    } else {
      setFormData({...formData, [e.target.name]: e.target.value});
      if (e.target.name === 'nextappointment') {
        const dateTime = e.target.value.split('T');
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData?.p_uhid || formData.patientId,
          name: props.patientsData?.titles ? `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}` : formData.patientName,
          status: 'Not Visited',
          notes: 'Booking Visit',
          patient_id: patientId
        });
      }
    }
  };

  const handlesubmit = () => {
    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('ScFetStimulatedReportGenerateWrap').innerHTML;

          const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
          };
          createNewAppointment();

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'SCFET'
            }
          };

          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
            Swal.fire({
              title: 'Successful.',
              text: 'Record added successful.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            });
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  return (
    <div id='ScFetStimulated'>
      <div className='ScFetStimulatedTemplate'>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img
              className='header_image'
              src={headerimage || '/placeholder.svg'}
              style={{
                width: '100%',
                margin: '0 auto'
              }}
            />
          </div>
          <h2 style={{display: 'flex', justifyContent: 'space-between'}}>
            SC-FET Stimulated Cycle Checklist and Chart
            {/* <span>
              Date{" "}
              <input
                type="date"
                className={`createTime ${show ? "hide" : "show"}`}
                name="date"
                onChange={(e) => handleChange(e, "date")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>&nbsp;{formData.date}</span>
            </span> */}
          </h2>

          <SinglePatientInfo patientsData={props.patientsData} handleChange={handleChange} />
        </div>

        <div className='detail'>
          <h3 className='mt-4 mb-3'>SC-FET Stimulated Cycle Details</h3>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Cycle Number :' name='cycleNumber' value={formData.cycleNumber} onChange={handleChange} show={true} minWidth='150px' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='No. of Embryos & Grade :' name='embryosGrade' value={formData.embryosGrade} onChange={handleChange} show={true} minWidth='200px' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Embryos Available :' name='embryosAvailable' value={formData.embryosAvailable} onChange={handleChange} show={true} minWidth='180px' />
            </div>
          </div>

          <div className='row pb-3'>
            <div className='col-md-4'>
              <div className='d-flex align-items-center gap-2' style={{fontSize: '18px'}}>
                <label className='mb-0 fw-semibold' htmlFor='trialCannulation'>
                  Trial Cannulation:
                </label>
                <select id='trialCannulation' name='trialCannulation' className='form-select' value={formData.trialCannulation} onChange={handleChange}>
                  <option value=''>Please Select</option>
                  <option value='Easy'>Easy</option>
                  <option value='Difficult'>Difficult</option>
                </select>
              </div>
            </div>

            <div className='col-md-6'>
              <div className='d-flex align-items-center gap-2' style={{fontSize: '18px'}}>
                <label className='mb-0 fw-semibold' htmlFor='antibioticsGiven'>
                  Antibiotics Given(doxy/probiotics):
                </label>
                <select id='antibioticsGiven' name='antibioticsGiven' className='form-select' value={formData.antibioticsGiven} onChange={handleChange}>
                  <option value=''>Please Select</option>
                  <option value='yes'>Yes</option>
                  <option value='no'>No</option>
                </select>
              </div>
            </div>
          </div>

          <div className='row pb-3'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Previous ET at EC :' name='previousEtEc' value={formData.previousEtEc} onChange={handleChange} show={true} minWidth='180px' />
            </div>
            <div className='col-md-4'>
              <div className='d-flex align-items-center gap-2' style={{fontSize: '18px'}}>
                <label className='mb-0 fw-semibold' htmlFor='shavingDone'>
                  Shaving Done:
                </label>
                <select id='shavingDone' name='shavingDone' className='form-select' value={formData.shavingDone} onChange={handleChange}>
                  <option value=''>Please select</option>
                  <option value='Yes'>Yes</option>
                  <option value='No'>No</option>
                </select>
              </div>
            </div>

            <div className='col-md-4'>
              <div className='d-flex align-items-center gap-2' style={{fontSize: '18px'}}>
                <label className='mb-0 fw-semibold' htmlFor='hysteroscopy'>
                  Hysteroscopy:
                </label>
                <select id='hysteroscopy' name='hysteroscopy' className='form-select' value={formData.hysteroscopy} onChange={handleChange}>
                  <option value=''>Please select</option>
                  <option value='Yes'>Yes</option>
                  <option value='No'>No</option>
                </select>
              </div>
            </div>
          </div>

          <h3 className='mt-3'>Baseline Scan</h3>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='Endometrial Thickness:'
                name='endometrialThickness'
                value={formData.endometrialThickness}
                onChange={handleChange}
                show={true}
                // endLabel="mm"
                minWidth='150px'
              />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Right Ovary :' name='rightOvary' value={formData.rightOvary} onChange={handleChange} show={true} minWidth='150px' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Left Ovary :' name='leftOvary' value={formData.leftOvary} onChange={handleChange} show={true} minWidth='150px' />
            </div>
          </div>
        </div>

        {showTables.medicationChart && (
          <TemplateTable
            id='medicationChart'
            title='Medication Chart'
            headers={medicationHeaders}
            rows={medicationRows}
            onRowsChange={(id, newRows) => setMedicationRows(newRows)}
            enableActions={true}
            onNill={() => handleNill('medicationChart', setShowTables)}
          />
        )}

        {showTables.follicularMonitoring && (
          <TemplateTable
            id='follicularMonitoring'
            title='Follicular Monitoring'
            headers={follicularHeaders}
            rows={follicularRows}
            onRowsChange={(id, newRows) => setFollicularRows(newRows)}
            enableActions={true}
            onNill={() => handleNill('follicularMonitoring', setShowTables)}
          />
        )}
        <h4 className='mt-4 mb-3'>HORMONE PROFILE</h4>
          {showTables.hormonalProfile && (
            <TemplateTable
              id='hormonalProfile'
              title=''
              headers={hormonalProfileHeaders}
              rows={hormonalProfileRows}
              onRowsChange={(id, newRows) => setHormonalProfileRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('hormonalProfile', setShowTables)}
            />
          )}


        <div className='d-flex align-items-start py-2' style={{gap: '10px'}}>
          <label htmlFor='advice' className='fw-bold' style={{whiteSpace: 'nowrap', paddingTop: '6px'}}>
            ADVICE:
          </label>
          <textarea className='Textarea' placeholder='Enter advice' id='advice' name='advice' value={formData.advice || ''} onChange={handleChange} rows='4' cols='100' />
        </div>


 <p style={{fontWeight: '600'}}>
          NEXT APPOINTMENT - <input name='nextAppointment' onChange={handleChange} type='date' />
        </p>
        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>

      <div id='ScFetStimulatedReportGenerate'>
        <div id='ScFetStimulatedReportGenerateWrap'>
          <Headers />
          <p className='Dani'></p>
          <div
            className='patient'
            style={{
              border: '1px solid black',
              borderRadius: '10px',
              marginBottom: '10px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>        

          <div style={{display: 'flex', marginTop: '10px'}}>
            <h4 style={{fontWeight: 600, marginRight: '5px'}}>SC-FET STIMULATED CYCLE CHECKLIST AND CHART</h4>
          </div>

          <div style={{display: 'flex', flexWrap: 'wrap', marginTop: '10px'}}>
            {renderReportfield('Cycle Number :', `${formData.cycleNumber ? formData.cycleNumber : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('No. of Embryos & Grade :', `${formData.embryosGrade ? formData.embryosGrade : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Embryos Available :', `${formData.embryosAvailable ? formData.embryosAvailable : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Trial Cannulation :', `${formData.trialCannulation ? formData.trialCannulation : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Antibiotics Given :', `${formData.antibioticsGiven ? formData.antibioticsGiven : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Previous ET at FC :', `${formData.previousEtEc ? formData.previousEtEc : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
             {renderReportfield('Shaving Done :', `${formData.shavingDone ? formData.shavingDone : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Hysteroscopy :', `${formData.hysteroscopy ? formData.hysteroscopy : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
          </div>

          <div style={{display: 'flex',  marginTop: '10px'}}>
            <h4 style={{fontWeight: 600, marginRight: '5px'}}>Baseline Scan</h4>
          </div>
          <div style={{display: 'flex', marginTop: '10px'}}>
            {renderReportfield('Endometrial Thickness :', `${formData.endometrialThickness ? formData.endometrialThickness : ''} mm`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Right Ovary :', `${formData.rightOvary ? formData.rightOvary : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Left Ovary :', `${formData.leftOvary ? formData.leftOvary : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
          </div>

          {showTables.medicationChart && (
            <>
              <div style={{display: 'flex', marginTop: '10px'}}>
                <h4 style={{fontWeight: 600, marginRight: '5px'}}>MEDICATION CHART</h4>
              </div>

              <div>
                <table
                  style={{
                    marginBottom: '10px',
                    border: '1px solid black',
                    width: '100%',
                    textAlign: 'center'
                  }}>
                  <thead>
                    <tr>{medicationHeaders.map((ele, ind) => renderTableTH(ele.label))}</tr>
                  </thead>
                  <tbody>
                    {medicationRows.map((row, i) => (
                      <tr key={i}>
                        {renderTableTD(row.sno)}
                        {renderTableTD(row.medication)}
                        {renderTableTD(row.genericName)}
                        {renderTableTD(row.dose)}
                        {renderTableTD(row.frequency)}
                        {renderTableTD(row.timing)}
                        {renderTableTD(row.route)}
                        {renderTableTD(row.days)}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}

          {showTables.follicularMonitoring && (
            <>
              <div style={{display: 'flex', marginTop: '10px'}}>
                <h4 style={{fontWeight: 600, marginRight: '5px'}}>FOLLICULAR MONITORING</h4>
              </div>

              <div>
                <table
                  style={{
                    marginBottom: '10px',
                    border: '1px solid black',
                    width: '100%',
                    textAlign: 'center'
                  }}>
                  <thead>
                    <tr>{follicularHeaders.map((ele, ind) => renderTableTH(ele.label))}</tr>
                  </thead>
                  <tbody>
                    {follicularRows.map((row, i) => (
                      <tr key={i}>
                        {/* {renderTableTD(row.date)} */}
                        {renderTableTD(row.day)}
                        {renderTableTD(row.rightOvary)}
                        {renderTableTD(row.leftOvary)}
                        {renderTableTD(row.endometrialThickness)}
                        {renderTableTD(row.notesActions)}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
          {showTables.hormonalProfile && (
              <>
                <div style={{display: 'flex', marginTop: '10px'}}>
                  <h4 style={{fontWeight: 600, marginRight: '5px'}}>HORMONE PROFILE</h4>
                </div>
                <div>
                  <table
                    style={{
                      marginBottom: '10px',
                      border: '1px solid black',
                      width: '100%',
                      textAlign: 'center'
                    }}>
                    <thead>
                      <tr>{hormonalProfileHeaders.map((ele, ind) => renderTableTH(ele.label))}</tr>
                    </thead>
                    <tbody>
                      {hormonalProfileRows.map((row, i) => (
                        <tr key={i}>
                          {renderTableTD(row.hormone)}
                          {renderTableTD(row.valueTestDate)}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}

          <div style={{marginBottom: '5px'}}>
            <div style={{fontWeight: '600', margin: '0 10px 10px 10px'}}>Advice:</div>
            <pre style={{margin: '0 10px 10px 10px', fontFamily: 'inherit', whiteSpace: 'pre-wrap'}}>{formData.advice ? formData.advice : ''}</pre>
          </div>

          <div style={{marginTop: '10px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
          <p className='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
